export class DistanceModel {
  kilometers: number;
  miles: number;
}
